const regrasJuridicas = [

  // ======================
  // TRABALHISTA
  // ======================

  {
    area: "trabalhista",
    acao: "Reclamação Trabalhista",

    palavras: [
      "demissão",
      "demitido",
      "dispensado",
      "verbas rescisórias",
      "fgts"
    ],

    pedidos: [
      "Saldo de salário",
      "Aviso prévio",
      "Multa de 40% do FGTS",
      "Liberação do FGTS",
      "Multa do art. 477 da CLT"
    ]
  },

  {
    area: "trabalhista",
    acao: "Horas Extras",

    palavras: [
      "hora extra",
      "jornada",
      "trabalhava até",
      "sábado",
      "domingo"
    ],

    pedidos: [
      "Pagamento de horas extras",
      "Reflexos em férias",
      "Reflexos em 13º",
      "Reflexos em FGTS"
    ]
  },

  {
    area: "trabalhista",
    acao: "Insalubridade",

    palavras: [
      "insalubridade",
      "produto químico",
      "calor",
      "ruído"
    ],

    pedidos: [
      "Adicional de insalubridade",
      "Perícia técnica judicial"
    ]
  },

  // ======================
  // CONSUMIDOR
  // ======================

  {
    area: "consumidor",
    acao: "Negativação Indevida",

    palavras: [
      "spc",
      "serasa",
      "nome sujo",
      "negativação"
    ],

    pedidos: [
      "Retirada do nome dos cadastros de inadimplentes",
      "Indenização por danos morais"
    ]
  },

  {
    area: "consumidor",
    acao: "Produto com Defeito",

    palavras: [
      "produto com defeito",
      "garantia",
      "assistência técnica"
    ],

    pedidos: [
      "Substituição do produto",
      "Restituição do valor pago",
      "Indenização por danos morais"
    ]
  },

  // ======================
  // FAMÍLIA
  // ======================

  {
    area: "familia",
    acao: "Pensão Alimentícia",

    palavras: [
      "pensão",
      "filho",
      "não paga pensão"
    ],

    pedidos: [
      "Fixação de pensão alimentícia",
      "Alimentos provisórios"
    ]
  },

  {
    area: "familia",
    acao: "Divórcio",

    palavras: [
      "divórcio",
      "separação"
    ],

    pedidos: [
      "Decretação do divórcio",
      "Partilha de bens"
    ]
  }

];

export default regrasJuridicas;